<div class="inactive-subscription-container">
    <div class="inactive-subscription-card">
        <div class="icon-container">
            <i class="far fa-exclamation-triangle icon"></i>
        </div>

        <div class="title">Subscription Inactive</div>

        <div class="message">This organization's subscription needs to be activated to continue using the platform. Please contact your administrator.</div>
    </div>
</div>
